import * as React from "react";
import { AuthLayoutComponents } from "./layout.c";
import { BoxLoader } from "@lib/components";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../mobx/components/index";

interface Props {
	loading: boolean;
	children: React.ReactNode;
}
interface State {
	pose_state: "visible" | "hidden";
}

@inject("store") @observer
export class AuthLayout extends MobxComponent<Props, State> {

	timeout: any;

	constructor(props: Props) {
		super(props);
		this.state = { pose_state: "hidden" };
	}

	componentDidMount() {
		this.timeout = setTimeout(() => this.setState({ pose_state: "visible" }), 200);
		if (this.injected.store.auth.token) {
			this.injected.store.router.push("/");
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	render() {
		const { children, loading } = this.props;
		const reseller = this.injected.store.reseller!;
		const logo_auth = reseller.admin.logo_auth;
		const resellerBackground = reseller?.admin.images?.background?.trim();
		const backgroundImage = resellerBackground || AuthLayoutComponents.DEFAULT_BG_IMAGE;
		const backgroundColorTint = reseller?.admin.colors?.backgroundTint;
		const loginBoxStyle = reseller?.admin.login_box_style ?? "classic";
		const resellerName = reseller.name || "CloudWaitress";

		return (
			<AuthLayoutComponents.Shell>
				<AuthLayoutComponents.LeftPanel>
					<AuthLayoutComponents.LeftImage src={backgroundImage} alt="" />
					<AuthLayoutComponents.LeftOverlay bg_tint={backgroundColorTint} />
					<AuthLayoutComponents.LeftFooter>
						&copy; {new Date().getFullYear()} {resellerName}
					</AuthLayoutComponents.LeftFooter>
				</AuthLayoutComponents.LeftPanel>

				<AuthLayoutComponents.RightPanel pose={this.state.pose_state} boxStyle={loginBoxStyle}>
					<AuthLayoutComponents.Content>
						<AuthLayoutComponents.LogoHeader>
							<img src={logo_auth} className="res-img" alt={`${resellerName} logo`} />
							<div>
								<AuthLayoutComponents.LogoTitle>{resellerName}</AuthLayoutComponents.LogoTitle>
								<AuthLayoutComponents.LogoSubtitle>Dashboard</AuthLayoutComponents.LogoSubtitle>
							</div>
						</AuthLayoutComponents.LogoHeader>

						<AuthLayoutComponents.ContentBox>
							<BoxLoader active={loading} boxStyle={loginBoxStyle} />
							{children}
						</AuthLayoutComponents.ContentBox>
					</AuthLayoutComponents.Content>
				</AuthLayoutComponents.RightPanel>
			</AuthLayoutComponents.Shell>
		);
	}

}
